<template>
<div :class="groupclass">
    <d-label v-if="label" :label="label" />
    <div>
    <input 
          :class="getclass"
          :type="gettype"
          :value="xvalue"
          max="2100-12-31"
          min="2000-01-01"
          step="false"
          autocomplete
          @click="updateValue($event.target.value)"
          @input.blur="updateValue($event.target.value)">
                    
    </div>
</div>
</template>

<script>
export default {
  props:{
    label:String,
    value:{type:Number,default:0},
    cols:Number,
    small:Boolean,
    large:Boolean,
    noborder:Boolean,
    time:Boolean
  },
  data () {
    return {
    }
  },
  methods: {
    updateValue: function (e) {
     var q=parseInt(e.substring(0,4))*10000+
             parseInt(e.substring(5,7))*100+
             parseInt(e.substring(8,10));
            if(isNaN(q)) q=0; 
      if (this.time) {
      var q1=parseInt(e.substring(11,13))*100+
             parseInt(e.substring(14,16));
          if(isNaN(q1)) q1=0; 
          q+=q1/10000
      }
      if (q!=this.value)
       this.$emit('input',q)
    }
  },
  computed: {
     gettype() {
       return this.time?"datetime-local":"date";
     },
     xvalue() {
        var s= this.value;
        if (s>=20000101 && s<99991231) {
           var s1=s+'';
           if (this.time) {
              var s2=(s % 1).toFixed(4).substring(2); // time
              return s1.substring(0,4)+'-'+s1.substring(4,6)+'-'+s1.substring(6,8)+
              'T'+s2.substring(0,2)+':'+s2.substring(2,4);   
           } else {
           return s1.substring(0,4)+'-'+s1.substring(4,6)+'-'+s1.substring(6,8);
           }
        } else {
           return '';
        }
        
     },
     getclass() {
       var aa="form-control";
       if (this.noborder) aa=aa+" noborder";
       if (this.small ) aa=aa+" small";
       if (this.large) aa=aa+" large";
       return aa;
      
    },
    groupclass() {
      if (this.cols && Number.isInteger(this.cols) && this.cols>0 && this.cols<13)
        return "col-"+this.cols;
      else 
         return "col";
       }
  }
}
</script>



// WEBPACK FOOTER //
// src/_eng/globals/ddate.vue